export default "__VITE_ASSET__Oift6B9x__"